import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { ProjectService } from './project.service';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { AddProjectsService } from '../../pages/admin/add-projects.service';
import {MatIconModule} from '@angular/material/icon'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';


@Component({
  selector: 'app-project',
  standalone: true,
  imports: [CommonModule,MatSnackBarModule, NgxSkeletonLoaderModule, MatIconModule, RouterModule],
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectComponent implements OnInit {
  resProject: any
  durationInSeconds = 5;
  project: any;
  isLoading = false;
  isClock = true;
  isAdmin = false;
  role: any;
  page: any;
  length!: number;
  paramPaginate = {
    start : 0,
    length: 5
  };
  nextpage = 1;

  constructor( private projectService: ProjectService, private router: Router, private addProjectService: AddProjectsService) { }

  ngOnInit() {
    this.role = localStorage.getItem('role')
    console.log(this.role)
    this.getProject();
  }

edit(id:string){
    const data = {
      id: id,
      type: 'edit'
    }
    this.router.navigate(['/add-project', id], {
      state: {value: data}
    })
  }

  goTodetail(status: string, id: any){
    if(status == 'IsComming'){
      return;
    }else if(status == 'Premium' && this.role != 'member' && this.role != 'admin'){
      this.router.navigate(['/login'])
    }else if(status == 'Premium' && this.role == 'member' && this.role == 'admin'){
      localStorage.setItem('link', 'project-detail')
      this.router.navigate(['project-detail', id], {
        state: {value: id}
      })
    }else{
      localStorage.setItem('link', 'project-detail')
      this.router.navigate(['project-detail', id], {
        state: {value: id}
      })
    }

  }

getProject(){
  this.isLoading = true;
  let page: any = {
    page: this.nextpage,
  }
  this.addProjectService.getProject(page).subscribe((value: any) => {
    this.isLoading = false;
    this.project = value.data;
    this.page = value.page;
    console.log(this.project);
  }, error => {
    this.isLoading = false;
  })
}
doNavigate(){
    this.nextpage++
    console.log(this.nextpage)
    this.getProject()
}
pervious(){
  this.nextpage--
  this.getProject()
}
}
